import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SearchLoading() {
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/confirmation", { state });
    }, 2500);
    return () => clearTimeout(timer);
  }, [navigate, state]);

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-white px-4 text-center">
      {/* Spinner */}
      <div className="mb-6">
        <svg
          className="h-14 w-14 animate-spin text-blue-600"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
      </div>

      {/* Text */}
      <p className="text-lg font-medium text-gray-700">
        <span className="text-2xl">🔍 Searching for the best fares...</span>
        <br className="hidden md:block" />
        <span className="mt-2 block text-sm text-gray-500">
          Please wait while we find the best routes and offers for you.
        </span>
      </p>
    </div>
  );
}
